<template>
	<ShareButton
		:classes="{'facebook-button': true}"
		:link="link"
	>
		<template #icon>
			<Icon
				class="icon-social"
				icon-name="logo-facebook"
				size="lg"
			/>
		</template>
	</ShareButton>
</template>

<script>
import ShareButton from './ShareButton';
import Icon from '@components/Icon';

export default {
	name:       'FbShareButton',
	components: { ShareButton, Icon },
	props:      {
		link: {
			type:     String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

$blue-fb: #4267B2;

.facebook-button::v-deep {
	color: var(--color-soft-white);
	background-color: $blue-fb;
	border-color: $blue-fb;
}

</style>
